'use strict';

function getKeys(obj) {
  return Object.keys(obj);
}

module.exports = getKeys;